import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData({
		url: 'https://rich.wenhua.com.cn/',
        title: 'wh7睿期大户室期货软件'
	}).then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()